module.exports = __webpack_public_path__ + "static/img/h5-gift-cash.887ec0e7.png";